import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 border-t border-bone-200 dark:border-charcoal-light/20 bg-bone-100/60 dark:bg-charcoal-light/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 space-y-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-terracotta/5 ring-1 ring-terracotta/15 overflow-hidden">
              <img src="/logo-mark.png" alt="Quiet Signals mark" className="w-7 h-7 object-contain" />
            </span>
            <span className="font-serif text-xl text-charcoal dark:text-bone">Quiet Signals</span>
          </div>
          <p className="text-sm text-charcoal-light dark:text-bone/65 leading-relaxed max-w-sm">
            A quiet corner of the internet for anyone trying to understand
            Functional Neurological Disorder — written from lived experience,
            not a prescription pad.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.22em] text-charcoal-light dark:text-bone/50 mb-4">
            Explore
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/what-is-fnd"
                data-testid="footer-link-what-is-fnd"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                What is FND
              </Link>
            </li>
            <li>
              <Link
                to="/symptoms"
                data-testid="footer-link-symptoms"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Symptoms & Types
              </Link>
            </li>
            <li>
              <Link
                to="/treatments"
                data-testid="footer-link-treatments"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Treatments
              </Link>
            </li>
            <li>
              <Link
                to="/for-kids"
                data-testid="footer-link-for-kids"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                For Kids
              </Link>
            </li>
            <li>
              <Link
                to="/my-story"
                data-testid="footer-link-my-story"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                My Story
              </Link>
            </li>
            <li>
              <Link
                to="/resources"
                data-testid="footer-link-resources"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Resources
              </Link>
            </li>
            <li>
              <Link
                to="/community"
                data-testid="footer-link-community"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Community
              </Link>
            </li>
            <li>
              <Link
                to="/support"
                data-testid="footer-link-support"
                className="text-charcoal dark:text-bone hover:text-terracotta dark:hover:text-terracotta transition"
              >
                Support this site
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.22em] text-charcoal-light dark:text-bone/50 mb-4">
            A quiet note
          </h4>
          <p className="text-sm text-charcoal-light dark:text-bone/65 leading-relaxed">
            This site is written from personal experience and is not a
            substitute for medical advice. If you’re ever frightened or
            unable to settle, please reach out to a clinician you trust — or
            in Australia, call <a href="tel:000" className="text-terracotta underline underline-offset-4">000</a> for emergencies.
          </p>
        </div>
      </div>

      <div className="border-t border-bone-200 dark:border-charcoal-light/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-charcoal-light dark:text-bone/55 tracking-wide">
            © {new Date().getFullYear()} Quiet Signals · Made with care.
          </p>
          <p className="text-xs text-charcoal-light dark:text-bone/55 italic">
            “You are not imagining this. You are not alone.”
          </p>
        </div>
      </div>
    </footer>
  );
}
